import React from 'react';
import { Play, Trash, ClockCounterClockwise } from '@phosphor-icons/react';

const triggerLabel = (t) => (t === 'feedback' ? 'refined' : t === 'material_change' ? 'auto-updated' : 'manual');

export const NarrationVersionList = ({ versions, activeId, loadNarration, deleteVersion }) => {
  if (!versions || versions.length <= 1) return null;
  return (
    <div className="bg-white border border-[#E5E7EB] rounded-xl p-4" data-testid="narration-versions">
      <p className="text-sm font-ibm font-semibold text-[#09090B] mb-2 flex items-center gap-1.5">
        <ClockCounterClockwise size={16} className="text-[#002FA7]" /> Version History
      </p>
      <div className="space-y-1.5">
        {versions.map(v => (
          <div key={v._id} data-testid={`narration-version-${v._id}`}
            className={`flex items-center justify-between gap-2 px-3 py-2 rounded-md border ${activeId === v._id ? 'border-[#002FA7] bg-[#002FA7]/5' : 'border-[#E5E7EB]'}`}>
            <div className="min-w-0">
              <p className="text-sm font-ibm font-semibold text-[#09090B] truncate">v{v.version} · {v.title}</p>
              <p className="text-[11px] text-[#6B7280] font-ibm">
                {new Date(v.created_at).toLocaleString()} · {triggerLabel(v.trigger)}{v.status !== 'ready' && ` · ${v.status}`}
              </p>
            </div>
            <div className="flex items-center gap-1.5 shrink-0">
              {v.status === 'ready' && (
                <button onClick={() => loadNarration(v._id)} data-testid={`narration-play-version-${v._id}`}
                  className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-ibm font-semibold bg-[#002FA7] text-white rounded-md hover:bg-[#00237D] transition-all">
                  <Play size={11} weight="fill" /> Load
                </button>
              )}
              <button onClick={() => deleteVersion(v._id)} title="Delete" data-testid={`narration-delete-version-${v._id}`}
                className="inline-flex items-center justify-center w-7 h-7 text-[#6B7280] hover:text-red-600 hover:bg-red-50 rounded-md transition-all">
                <Trash size={13} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
